var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{attrs:{"gutter":20,"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('div',[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }